<template>
  <span>
    <div class="col-md-12">
      <div class="table-responsive">
        <table id="dataTableExample" class="table table-hover">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Spare Part</th>
              <th>QTY</th>
              <th>Comments</th>
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <loading-table :isLoading="isLoading" cols="14"></loading-table>
            <tr v-if="form.requisition_details.length == 0">
              <td colspan="14" class="text-center">No data Found</td>
            </tr>
            <tr
              v-for="(requisition_detail, sr) in form.requisition_details"
              :key="`requisition_detail${sr}`"
            >
              <td>{{ sr + 1 }}.</td>
              <td>
                <my-select
                  disableFormControl="true"
                  :selection.sync="requisition_detail.spare_part_id"
                  :suggestions="spareParts"
                  placeholder="Select Spare Parts"
                ></my-select>
                <!-- :id="`requisition_detail${sr}`" -->
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="QTY"
                  v-model="requisition_detail.qty"
                />
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Comments"
                  v-model="requisition_detail.comments"
                />
              </td>
              <td>
                <div class="text-center">
                  <button
                    class="btn btn-danger btn-sm"
                    @click="deleteRequisitionDetail(requisition_detail)"
                    v-if="!requisition_detail.id"
                  >
                    Delete
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="
                      delete_requisition_detail_data(requisition_detail.id)
                    "
                    v-else
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="form.requisition_details">
              <td
                colspan="14"
                align="center"
                @click="addEmptyRequisitionDetails()"
                style="
                  background-color: #6571ff;
                  color: white;
                  border-radius: 10px;
                  box-shadow: none;
                "
              >
                Add New Row
              </td>
            </tr>
          </tbody>
        </table>
        <!-- /Table -->
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "RequisitonDetailFormWidget",
  props: ["form"],
  data() {
    return {
      spareParts: [
        { id: 1, name: "Spare 1" },
        { id: 2, name: "Spare 2" },
      ],
    };
  },

  methods: {
    deleteRequisitionDetail(speed) {
      this.form.requisition_details = this.form.requisition_details.filter(
        (ar) => ar != speed
      );
    },
    addEmptyRequisitionDetails() {
      this.form.requisition_details.push({
        company_id: this.company.id,
        spare_part_id: "",
        qty: "",
        comments: "",
      });
    },
    async delete_requisition_detail_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=requisition_details`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
